<script lang="ts">
  import RatingSummary from './RatingSummary.svelte';

  export let testFreakData;
  const reviewBGPath = `${window['ACC'].config.extraThemeResourcePath}/micro-front-end/assets/images/yellow-x.svg`;

  $: ({ pro_score_dist_all, user_score_dist_all, your_score_dist, score } = testFreakData || {});
</script>

{#if testFreakData && score > 0}
  <section style:--url={`url(${reviewBGPath})`} class="product-rating-container">
    <section class="left">
      <RatingSummary scoreDist={{ pro_score_dist_all, user_score_dist_all, your_score_dist }} {score} />
    </section>
    <section class="right">
      <!-- <FeatureSummary /> -->
    </section>
  </section>
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .product-rating-container {
    display: flex;
    background: none;
    flex-direction: column;
    gap: 8px;

    @include desktop-min-width {
      min-height: 324px;
      background:
        var(--url) no-repeat right/contain,
        linear-gradient(-55deg, $neutral-light-04 50%, $color-bg-grey 50%);
      flex-direction: row;
      padding-inline: 48px;
      align-items: center;
      justify-content: space-between;
    }

    .right {
      max-width: 100vw;
      background-color: $neutral-light-04;
      padding-block: 24px;
      overflow-x: auto;

      @include desktop-min-width {
        max-width: unset;
        background-color: unset;
        padding-block: unset;
        overflow-x: unset;
      }

      &:empty {
        padding-block: 0;
      }
    }
  }
</style>
